module.exports = __webpack_public_path__ + "static/media/java.ee491c0f.svg";